export default "__VITE_ASSET__TUsOeZlD__$_?url__"